export default __webpack_public_path__ + "static/media/placeholder_dummy2016-ernaehrungsberatung01-mobile-de.cd22f277.png";